import React, { Component } from 'react';
const axios = require('axios')

export default class Result extends Component {
  constructor(props){
    super(props)
    this.state = {
      question1State: 0, 
      question2State: 0
    }
  }
  pushData(is_1, payload){
    if (is_1){
      this.setState({question1State: 1})
    }else{
      this.setState({question2State: 1})
    }
    // console.log(payload)
    let that = this
    axios.post('https://a6jt42ycll.execute-api.us-east-2.amazonaws.com/prod/marketo-service', {
      action: "push",
      payload
    })
    .then(res => {
      console.log(res.data)
      that.setState({question1State: is_1 ? 2 : 0, question2State: is_1 ? 0 : 2})
    })
    .catch(err => {
      console.error(err)
      that.setState({question1State: 0, question2State: 0})
    })
  }
  render(){
    // console.log(this.state)
    return(
    <>
      <div className="result-wrapper">
        <div className="container">
          <section className="blue-quote">
            <div className="mask"></div>
            <span className="icon-quote"></span>
            <p>“Digital business executives and software development leaders should not settle for separate digital labs; instead, create a seamless organization that is empowered to work differently, with innovation as part of its DNA.”</p>
            <hr className="stubby" />
            <p className="function">via Forrester report The Downside Of Digital Labs</p>
          </section>
          <section className="tip">
            <span id="tip3" className="lead">Tip #3</span>
            <h2 className="l2-heading">Reach unexpected innovators by making innovation mobile and real-time</h2>
            <hr className="stubby" />
            <p>The software “sharing” revolution is much more far-reaching than the ability to hail a ride or order lunch from a smartphone app. Changing expectations among employees and customers, combined with emerging technologies allow today's companies unprecedented opportunities for accessing and capitalizing on the untapped knowledge of their employees - wherever they are, on any device, and whenever they have an idea.</p>
            <p>That translates to collecting real-time data and feedback to make the next generation of products even better or it could mean taking formerly isolated and mobile personnel, such as production line workers and field researchers, and bringing them into the innovation process.</p>
            <p>In either case, it means collecting the best ideas straight from the source by speaking their language. As for those smartphones: every company should be making use of them. Nearly three-quarters of all adults in the U.S. own a smartphone today, according to the Pew Research Center, and that figure jumps to an incredible 92% when you zoom in on millennials (adults aged 18-34). Take advantage of mobile saturation by enabling innovation anytime, anywhere, and from any device.</p>
          </section>
          <section className={`question ${this.state.question1State === 1 ? 'busy' : this.state.question1State === 2 ? 'done' : ''}`}>
            {
              this.state.question1State === 1 && <div className="mask"></div>
            }
            {
              this.state.question1State === 2 && <h3 className="l5-heading">Thank you!</h3>
            }
            {
              (this.state.question1State === 0 || this.state.question1State === 1) &&
              <>
                <h3 className="l5-heading">Do you have an innovation program?</h3>
                <div className="button-container">
                  <button className="button secondary dark" onClick={(e) => this.pushData(true, {
                    Email: this.props.email,
                    existing_innovation_program: 'Yes'
                  })}>Yes</button>
                  <button className="button secondary dark" onClick={(e) => this.pushData(true, {
                    Email: this.props.email,
                    existing_innovation_program: 'No'
                  })}>No</button>
                </div>
              </>
            }
          </section>
          <section className="tip">
            <span id="tip4" className="lead">Tip #4</span>
            <h2 className="l2-heading">Motivate your employees and other innovators by inspiring them</h2>
            <hr className="stubby" />
            <p>While we encourage organizations to make their innovation challenges as inclusive as possible, the truth is that not everyone will participate, even if they are only asked to vote on ideas. And that's okay: the point is not to force everyone to participate, but to provide the option to those motivated enough to do so. Nearly two-thirds (64%) of surveyed customers use Spigit to engage employees across the enterprise, and another 64% believe participation from at least a quarter of their target audience would be considered a success.</p>
            <p>Ultimately, however, quantity should never trump quality. That's why the approach to motivating employees and innovators is so important. Consider adding rewards and incentives, as well as elements of gamification. Rewards that align with the culture of your organization will have the most impact. We've seen incredibly high participation levels by offering creative rewards such as lunch with the CEO, or a company paid get-away. And remember to celebrate success at every stage, even if it's a small win.</p>
          </section>
          <section className="quote">
            <p>“Crowdsourcing applications typically include mechanisms to attract the desired participants, stimulate relevant contributions and select winning ideas or solutions. In other words, crowdsourcing means leveraging the collective intelligence of a diverse group of stakeholders to solve a problem.”</p>
            <hr className="stubby" />
            <p className="function">via Gartner's 2016 report The Practices That Deliver the Biggest Bang for Your Bimodal Buck</p>
          </section>
          <section className="tip">
            <span id="tip5" className="lead">Tip #5</span>
            <h2 className="l2-heading">Aim beyond one-and-done</h2>
            <hr className="stubby" />
            <p>In the beginning, achieving quick wins is important, but the end game should be a more all-encompassing vision for the company. That vision should be a culture of innovation executing on business goals. To work toward that vision, establish both easy-to-reach guide posts as well as more ambitious targets, and be sure to mix and match innovation initiatives for a multi-pronged approach to generating ideas.</p>
            <p>Crowdsourcing is a powerful, proven way to surface great ideas from across the company, and it's one that can be used for everything from day-to-day issues to long-term obstacles. Additionally, other worthwhile innovation methods include the “Shark Tank,” where an individual or group presents an idea to a panel of subject matter experts, and hackathons, one-day or weekend-long events where engineers experiment with testing new ideas.</p>
            <p>Regardless of approach, don't let innovation itself become a one-hit wonder or siloed department. Innovation management solutions like Spigit work well with pre-existing tools for communication and collaboration. Get buy-in from a wide-ranging collective of experts and peers, and don't stop iterating on your innovation program. In other words, disrupt and keep on disrupting.</p>
          </section>
          <section className={`question ${this.state.question2State === 1 ? 'busy' : this.state.question2State === 2 ? 'done' : ''}`}>
          {
              this.state.question2State === 1 && <div className="mask"></div>
            }
            {
              this.state.question2State === 2 && <h3 className="l5-heading">Thank you!</h3>
            }
            {
              (this.state.question2State === 0 || this.state.question2State === 1) &&
              <>
                <h3 className="l5-heading">Do you use a tool to collect ideas from employees, partners, or customers?</h3>
                <div className="button-container">
                  <button className="button secondary dark" onClick={(e) => this.pushData(false, {
                    Email: this.props.email,
                    other_tools_used_for_ideas: 'Yes'
                  })}>Yes</button>
                  <button className="button secondary dark" onClick={(e) => this.pushData(false, {
                    Email: this.props.email,
                    other_tools_used_for_ideas: 'No'
                  })}>No</button>
                </div>
              </>
            }
          </section>
          <section className="red-quote">
            <p>Successful innovation programs run frequent ideation challenges to <span className="red">crowdsource ideas from employees</span>, partners, and customers throughout the year.</p>
          </section>
          <section className="tip">
            <span id="tip6" className="lead">Tip #6</span>
            <h2 className="l2-heading">Pick the right software and partner</h2>
            <hr className="stubby" />
            <p>There is a lot an organization can do if it has never attempted to create an innovation program before: priorities include getting sponsors on board and evangelizing colleagues to support the cause. But when it comes to scaling innovation across the enterprise and driving impactful business results in the long-term, the best way forward is through collaboration with an innovation management solution and partner.</p>
            <p>As far as software, enterprise-class organizations require enterprise-class solutions, or to put it another way, the ability to easily scale across multiple business units, seamlessly integrate with existing systems, and meet the high bar of security requirements. The ideal solution also needs to be flexible enough to make innovation a repeatable business practice, engaging enough to sustain collaboration, and powerful enough to surface and select ideas with the greatest business value. Finally, and perhaps most important of all, the solution must be supported by an expert team experienced in the practice of innovation.</p>
          </section>
        </div>
      </div>
      <section className="resources">
        <div className="container">
          <h2 className="l2-heading">Additional resources</h2>
          <p>Get additional tips and advice for building successful innovation programs.</p>
          <ul>
            <li>
              <div className="img-wrap">
                <img src="https://media.planview.com/spigit-blog-media/img/resource3.jpg" alt="resource 1" />
              </div>
              <div className="body">
                <span className="lead">Webinar</span>
                <h3><a href="https://info.planview.com/fidelity-_webinar_im_en_watch.html" target="_blank" rel="noopener noreferrer">How Fidelity Investments Runs Their Innovation Program</a></h3>
              </div>
            </li>
            <li className="vertical">
              <div className="img-wrap">
                <img src="https://media.planview.com/spigit-blog-media/img/resource2.jpg" alt="resource 2" />
              </div>
              <div className="body">
                <span className="lead">Benchmark report</span>
                <h3><a href="https://info.planview.com/rs/456-QCH-520/images/2018_Spigit_State_of_Crowdsourced_Innovation.pdf" target="_blank" rel="noopener noreferrer">2019 State of Crowdsourced Innovation Report</a></h3>
              </div>
            </li>
            <li>
              <div className="img-wrap">
                <img src="https://media.planview.com/spigit-blog-media/img/resource1.jpg" alt="resource 3" />
              </div>
              <div className="body">
                <span className="lead">Article</span>
                <h3><a href="https://blog.planview.com/crowdsourced-innovation-executive-buy-in/" target="_blank" rel="noopener noreferrer">6 Steps to Getting Executive Buy-in for an Innovation Program</a></h3>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section className="products-demo">
        <div className="container">
          <img src="https://d1ru3055gppavs.cloudfront.net/img/badge-spigit-light.svg" alt="" height="56" />
          <hr className="stubby" />
          <h2 className="l2-heading">Sign up for a live Spigit demo</h2>
          <a className="button large primary has-subtext" href="https://info.planview.com/innovation-management-_demo-on-demand_im_en_reg.html" target="_blank" rel="noopener noreferrer">Schedule Demo<span className="subtext">Spigit Innovation Management</span></a>
        </div>
      </section>
    </>
    );
  }
}